const e=e=>"string"==typeof e?e.replace(/<br\s?\/?>/gi," ").replace(/(<.*?>|\s(?=\s))/g,"").trim():e;export{e as default};
